import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { Maintenance, StatusType } from '@vi-iot/client';

import { AppState } from '../app.state';

import { StatusPageState } from './status-page.state';

export namespace StatusPageSelectors {
  export const statusPageState = (state: AppState): StatusPageState => state.status;

  export function getState(): MemoizedSelector<
    AppState,
    StatusPageState,
    DefaultProjectorFn<StatusPageState>
  > {
    return createSelector(statusPageState, (state: StatusPageState) => state);
  }

  export function getStatus(): MemoizedSelector<AppState, string, DefaultProjectorFn<string>> {
    return createSelector(statusPageState, (state: StatusPageState) => state.status);
  }

  export function getScheduledMaintenance(): MemoizedSelector<
    AppState,
    Maintenance[],
    DefaultProjectorFn<Maintenance[]>
  > {
    return createSelector(statusPageState, (state: StatusPageState) => state.maintenances);
  }

  export function shouldMaintenanceBannerBeDisplayed(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      statusPageState,
      (state: StatusPageState) =>
        (state.getStatusLoaded && state.status !== StatusType.Operational) ||
        (state.getMaintenancesLoaded && state.maintenances.length > 0)
    );
  }
}
